import MultiplePersonMatchDialog from './MultiplePersonMatchDialog';
export default MultiplePersonMatchDialog;